import {configureStore} from "@reduxjs/toolkit"
import { adminReducer } from "./reducers/adminReducer.js";
import { courseReducer } from "./reducers/courseReducer.js";
import { userReducer } from "./reducers/userReducer.js"



const store = configureStore({
    reducer:{
        user : userReducer,
        courses : courseReducer,
        admin: adminReducer
    },
})

export default store;

export const server = "https://e-shiksha.onrender.com/api/v1"